import { render, staticRenderFns } from "./help-page.vue?vue&type=template&id=5aa241de&scoped=true&"
import script from "./help-page.vue?vue&type=script&lang=js&"
export * from "./help-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa241de",
  null
  
)

export default component.exports